import {useEffect} from 'react';
import BaseLayout from '../../Components/shared/BaseLayout';
import LoginForm from '../../Components/EAP/LoginForm';
import analyticsService, {ANALYTICS_EVENTS} from '../../analyticsService';
import {EAP_TITLE} from '../../constants';
import HJEAPLogo from '../../static/images/HJEAPLogo.svg';

const EAP = () => {
    useEffect(() => {
        document.title = EAP_TITLE;
        analyticsService.track(ANALYTICS_EVENTS.eapPortal.pageOpened);
    }, []);

    return (
        <BaseLayout headerLogo={HJEAPLogo}>
            <LoginForm/>
        </BaseLayout>
    );
};

export {EAP as TestableEAP};
export default EAP;
